export default __webpack_public_path__ + "a12b0e65deee9bf35f9fcd238271ca0a.png";